import React from "react";
import { INVESTMENT } from "../../mock/mock";
import { Check, ArrowRight } from "lucide-react";
import { trackEvent } from "../../lib/analytics";

export default function Investment() {
  return (
    <section id="investment" className="bg-[#fdfaf5]">
      <div className="max-w-6xl mx-auto px-4 lg:px-8 py-16 md:py-24">
        <div className="text-center max-w-3xl mx-auto">
          <p className="eyebrow text-lg">{INVESTMENT.eyebrow}</p>
          <div className="mx-auto mt-3 ornament-line" />
          <h2 className="mt-4 font-serif-display text-3xl md:text-5xl leading-tight text-[#1a1a1a]">
            {INVESTMENT.heading}
          </h2>
        </div>

        <div className="mt-12 mx-auto max-w-3xl rounded-3xl border border-[#e2d5bb] bg-white overflow-hidden shadow-[0_30px_60px_-40px_rgba(0,0,0,0.25)]">
          <div className="bg-[#7a1e2f] text-white px-6 md:px-10 py-6 md:py-8 flex flex-wrap items-end justify-between gap-4">
            <div>
              <div className="text-[11px] tracking-[0.2em] uppercase text-white/70">{INVESTMENT.cohort}</div>
              <div className="mt-1 font-serif-display italic text-2xl md:text-3xl">Take The Stage</div>
            </div>
            <div className="text-right">
              <div className="font-serif-display text-4xl md:text-6xl">{INVESTMENT.price}</div>
              <div className="text-white/70 text-sm tracking-widest">{INVESTMENT.currency} · {INVESTMENT.spots}</div>
            </div>
          </div>

          <div className="px-6 md:px-10 py-8 md:py-10">
            <p className="text-[15px] text-[#1a1a1a]/75">Full program — training, intensive, and Show Night included.</p>
            <ul className="mt-6 space-y-3">
              {INVESTMENT.bullets.map((b) => (
                <li key={b} className="flex items-start gap-3 text-[15px] text-[#1a1a1a]/85">
                  <span className="mt-1 h-5 w-5 rounded-full bg-[#f3ead9] text-[#c9a961] grid place-items-center shrink-0"><Check size={12} /></span>
                  <span>{b}</span>
                </li>
              ))}
            </ul>

            <div className="mt-8 flex flex-wrap items-center gap-4">
              <a href="#apply" onClick={() => trackEvent("cta_click", { label: "investment_apply_now", location: "investment" })} className="btn-primary rounded-full px-6 py-3.5 text-sm tracking-wider uppercase inline-flex items-center gap-2">
                Apply Now <ArrowRight size={16} />
              </a>
              <span className="text-sm text-[#1a1a1a]/60">Applications reviewed personally.</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
